import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { ASSOC } from '../mock';
import { useAuth } from '../context/AuthContext';
import EditableImage from './EditableImage';

// Decorative RAE-style crest built with CSS (avoids using the original copyrighted badge).
// Admins can right-click to replace it with a real logo image (stored as an image override).
function Crest({ side, w, h }) {
  return (
    <div className="flex flex-col items-center justify-center select-none">
      <div
        className="relative flex items-center justify-center rounded-md"
        style={{
          width: w,
          height: h,
          background: 'radial-gradient(circle at 50% 35%, #1d4a78, #0f2a45)',
          boxShadow: '0 2px 10px rgba(0,0,0,0.35)',
        }}
      >
        <Shield size={Math.min(w, h) * 0.45} color="var(--gold)" strokeWidth={1.5} />
        <span
          className="font-title absolute text-[10px] tracking-widest"
          style={{ color: 'var(--cream)', bottom: 6 }}
        >
          {side === 'right' ? 'RAE' : 'TAS'}
        </span>
      </div>
    </div>
  );
}

function EditableCrest({ side, w, h }) {
  return (
    <EditableImage
      imgKey={`header-crest-${side}`}
      alt={`${side} association crest`}
      fallback={<Crest side={side} w={w} h={h} />}
      wrapperClassName="hidden sm:block flex-shrink-0"
      className="rounded-md object-cover"
      style={{ width: w, height: h, boxShadow: '0 2px 10px rgba(0,0,0,0.35)' }}
    />
  );
}

export default function Header() {
  const { settings, org } = useAuth();
  const h = (settings && settings.header) || {};
  const layout = (settings && settings.layout) || {};
  const title = h.title || (org && org.name) || ASSOC.name;
  const motto = h.motto || (org && org.tagline) || ASSOC.motto;
  const ubique = h.ubique || ASSOC.ubique;
  const cw = Number(layout.crestWidth) || 120;
  const ch = Number(layout.crestHeight) || 90;
  return (
    <header style={{ background: 'linear-gradient(180deg, var(--maroon), var(--maroon-dark))' }}>
      <div className="max-w-6xl mx-auto px-4 py-5 flex items-center justify-between gap-4">
        <EditableCrest side="left" w={cw} h={ch} />
        <Link to="/" className="flex-1 text-center group min-w-0">
          <h1
            className="font-title leading-tight"
            style={{ color: 'var(--cream)', fontSize: 'clamp(1.4rem, 3.4vw, 2.7rem)', fontWeight: 700, letterSpacing: '0.5px' }}
          >
            {title}
          </h1>
          {layout.showUbique !== false && (
            <p className="font-title italic mt-1" style={{ color: '#e7c98a', fontSize: 'clamp(0.8rem,1.6vw,1.05rem)' }}>
              {ubique} {'\u2014'} {motto}
            </p>
          )}
        </Link>
        <EditableCrest side="right" w={cw} h={ch} />
      </div>
    </header>
  );
}
